import clsx from 'clsx';
import React, { FC, memo, PropsWithChildren } from 'react';
import {
    ModuleTheme,
    ModuleTheme1,
    DisplayOptionsComposition,
    HeightComposition,
} from '~/lib/data-contract';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import styles from './block-wrapper.module.css';
import { useModule } from '~/templates';

type Props = PropsWithChildren &
    ModuleTheme &
    ModuleTheme1 &
    DisplayOptionsComposition &
    HeightComposition & {
        index?: number;
        className?: string;
        hasGutter?: boolean;
    };

const BlockWrapper: FC<Props> = memo((props) => {
    const {
        hideMobile,
        hideDesktop,
        spacingTop,
        height:initialHeight,
        backgroundColor,
        children,
        className,
        ...rest
    } = props;

    const height = initialHeight ?? 'normal';


    const { index } = useModule();

    return (
        <ModuleContainer
            spacingTop={index === 0 ? 'none' : spacingTop}
            hideMobile={hideMobile}
            hideDesktop={hideDesktop}
            {...rest}
        >
            <div className={clsx(styles[`${height}Root`], className)} style={{ backgroundColor }}>
                {children}
            </div>
        </ModuleContainer>
    );
});

export default BlockWrapper;
